export default __webpack_public_path__ + "static/6-421bc703acd7dda02f356b1295ffda0c.jpg";